import React from "react";
import { Languages, X } from "lucide-react";
import { useLang } from "../context/LanguageContext";

// A one-time, always-in-English escape hatch shown when we auto-picked a non-English UI from the
// visitor's region — so an English speaker who got, say, French by mistake can switch back in one tap.
export const LangGeoHint = () => {
  const { autoLang, clearAutoLang, setLang } = useLang();
  if (!autoLang) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 bg-[#0f2a1a] text-white rounded-full pl-4 pr-2 py-2 shadow-xl" data-testid="lang-geo-hint">
      <Languages size={16} className="text-[#4ade80] shrink-0" />
      <button onClick={() => setLang("en")} data-testid="lang-geo-view-english"
        className="text-sm font-bold underline underline-offset-2 hover:text-[#4ade80] transition-colors whitespace-nowrap">
        View in English?
      </button>
      <button onClick={clearAutoLang} data-testid="lang-geo-dismiss" aria-label="Dismiss"
        className="text-white/70 hover:text-white rounded-full p-1 transition-colors">
        <X size={16} />
      </button>
    </div>
  );
};

export default LangGeoHint;
